<template>
	<v-layout :fill-height="fillHeight" wrap class="review-quote">
		<v-flex class="flex-column review-quote__quote">
			<v-card class="fill-height flex-column scroll-card">
				<div class="quote-builder__card-inner inner-scroll">
					<v-card-title class="pt-0">
						<h3 class="subheading font-weight-bold secondary--text">
							STEP 4: Review & Prep Quote
						</h3>
					</v-card-title>

					<v-card-text
						class="pa-0 mx-3 inner-scroll__scroller proposal-border"
					>
						<v-card
							class="scroll-card fill-height"
							color="lightbg"
							flat
						>
							<v-card-text class="py-0">
								<proposal-header
									:document="document"
								></proposal-header>
							</v-card-text>

							<v-card-text class="pb-0">
								<proposal-table
									:document="document"
									:line_items_editable="true"
								></proposal-table>
							</v-card-text>
						</v-card>
					</v-card-text>
				</div>
			</v-card>
			<v-card-actions class="pb-0 px-0">
				<v-spacer></v-spacer>
				<v-btn flat exact :to="getBuilderUrl(currentDocument, 1)">
					<div class="v-icon v-icon--left">
						<fa-icon
							:icon="['far', 'plus']"
							transform="shrink-4"
							size="xs"
						/>
					</div>
					Add Another Product
				</v-btn>
			</v-card-actions>
		</v-flex>

		<v-flex class="review-quote__notes" style="position: relative;">
			<v-card
				class="fill-height scroll-card"
				color="lightbg"
				style="overflow: hidden"
			>
				<v-navigation-drawer
					v-model="customerDrawer"
					right
					floating
					absolute
					disable-resize-watcher
				>
					<customer-form
						@close="closeDrawer"
						@save="saveCustomer"
						ref="form"
					></customer-form>
				</v-navigation-drawer>

				<div class="quote-builder__card-inner inner-scroll">
					<div class="inner-scroll__scroller">
						<v-card-title class="pt-0">
							<h3
								class="subheading font-weight-bold secondary--text"
							>
								a. Add Customer Info
							</h3>
						</v-card-title>

						<v-card-text class="py-0">
							<v-checkbox
								v-model="for_customer"
								class="mt-0"
								color="primary"
								label="Quote is for a customer"
								@change="handleForCustomerChange"
								:disabled="disabled"
								:ripple="false"
							></v-checkbox>

							<transition-expand>
								<div
									v-show="
										for_customer && document.customer_name
									"
									class="proposal-header__block"
								>
									<address-display
										:object="document"
										prefix="customer_"
										title="Customer Information:"
									>
										<div
											class="address__actions"
											slot="address-actions"
										>
											<v-btn
												icon
												small
												@click="editCustomer"
												class="ma-0 success--text"
											>
												<fa-icon
													icon="pencil-alt"
													class
													size="sm"
												/>
											</v-btn>
											<v-btn
												icon
												small
												@click="clearCustomer"
												class="ma-0"
											>
												<fa-icon
													:icon="['fal', 'times']"
													class
													size="lg"
												/>
											</v-btn>
										</div>
									</address-display>
								</div>
							</transition-expand>
						</v-card-text>

						<v-card-title>
							<h3
								class="subheading font-weight-bold secondary--text"
							>
								b. Add Notes to Quote
							</h3>
						</v-card-title>

						<v-card-text class="py-0">
							<v-textarea
								v-model="messages"
								outline
								name="proposal_messages"
								solo
								flat
								@blur="save('messages', messages)"
								:disabled="disabled"
							></v-textarea>

							<v-checkbox
								v-model="show_prices.list_price"
								hide-details
								class="mt-0 mb-1"
								color="primary"
								label="Suggested List Price"
								@change="
									save(
										'show_line_item_prices',
										show_prices.list_price
									)
								"
								:disabled="disabled"
								:ripple="false"
							></v-checkbox>

							<v-checkbox
								v-model="show_prices.customer_price"
								hide-details
								class="my-0"
								color="primary"
								label="End User Price"
								v-if="for_customer"
								@change="
									save(
										'show_customer_price',
										show_prices.customer_price
									)
								"
								:disabled="disabled"
								:ripple="false"
							></v-checkbox>

							<v-checkbox
								v-model="show_prices.net_price"
								hide-details
								class="my-0"
								color="primary"
								label="Dealer Net Price"
								v-if="!for_customer"
								@change="
									save(
										'show_net_price',
										show_prices.net_price
									)
								"
								:disabled="disabled"
								:ripple="false"
							></v-checkbox>
						</v-card-text>
					</div>

					<v-card-text class="pb-0">
						<div class="text-xs-center">
							<v-btn
								large
								@click="handlePreviewAndSend"
								color="primary"
								>Preview & Send</v-btn
							>
						</div>
					</v-card-text>
				</div>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import AddressDisplay from "@components/partials/AddressDisplay";
import ProposalHeader from "@components/partials/ProposalHeader";
import ProposalTable from "@components/partials/ProposalTable";
import TransitionExpand from "@components/partials/TransitionExpand";
import CustomerForm from "@components/partials/CustomerForm";
var { mainRoutes } = require("@root/mixins");

export default {
	mixins: [mainRoutes],

	data() {
		return {
			customerDrawer: false,
			notes: "",
			messages: "",
			for_customer: false,
			disabled: false,
			show_prices: {
				list_price: true,
				customer_price: false,
				net_price: true
			}
		};
	},

	components: {
		ProposalHeader,
		ProposalTable,
		TransitionExpand,
		CustomerForm,
		AddressDisplay
	},

	computed: {
		...mapGetters(["privacy", "dark"]),

		parts() {
			const parts = this.document.line_items.filter(item => item.part_id);

			return parts;
		}
	},

	methods: {
		...mapActions("documents", {
			UPDATE_DOCUMENT_FIELD: "updateDocumentField",
			POST_DOCUMENT_CUSTOMER: "postDocumentCustomer",
			DELETE_DOCUMENT_CUSTOMER: "deleteDocumentCustomer"
		}),

		...mapMutations("documents", {
			UPDATE_DOCUMENT_FIELDS: "updateDocumentFields"
		}),

		save(field, value) {
			if (value != this.document[field]) {
				let params = {};
				params[field] = value;

				this.disabled = true;

				return this.UPDATE_DOCUMENT_FIELD({
					document_number: this.number,
					field,
					params
				}).then(() => {
					this.disabled = false;
				});
			}
		},

		handleForCustomerChange() {
			this.save("for_customer", this.for_customer);

			if (this.for_customer) {
				this.showUserPriceModal();
			}
		},

		showUserPriceModal() {
			this.$swal({
				title: "Notice",
				text: "Please set End User price for each item in quote.",
				type: "warning",
				confirmButtonText: "Okay"
			});
		},

		handlePreviewAndSend() {
			if (this.for_customer) {
				const needsPrice = this.parts.filter(item => !item.quote_price)
					.length;

				if (needsPrice) {
					this.showUserPriceModal();
					return;
				}
			}

			this.nextStep(5);
		},

		saveCustomer(form) {
			this.POST_DOCUMENT_CUSTOMER({
				document_number: this.number,
				data: form
			})
				.then(data => {
					this.closeDrawer();
				})
				.catch(error => {
					error = Object.assign({}, error);
					this.$refs.form.errors.record(error.response.data.errors);
				});
		},

		editCustomer() {
			this.customerDrawer = true;
			this.$refs.form.populateForm(this.document);
		},

		clearCustomer() {
			this.$set(this, "for_customer", false);
			this.$refs.form.resetForm();
			this.disabled = false;

			this.DELETE_DOCUMENT_CUSTOMER({
				document_number: this.number
			})
				.then(data => {
					this.save("for_customer", false);
				})
				.catch(error => {
					//TODO Catch errors
				});
		},

		closeDrawer() {
			if (this.document.customer_name === null) {
				this.$set(this, "for_customer", false);
				this.save("for_customer", false);
			}

			this.customerDrawer = false;
		}
	},

	created() {
		this.messages = this.document.messages;
		this.for_customer = this.document.for_customer;
		this.show_prices.net_price = this.document.show_net_price;
		this.show_prices.customer_price = this.document.show_customer_price;
		this.show_prices.list_price = this.document.show_line_item_prices;

		// if (this.document.customer_name) {
		// 	this.for_customer = true;
		// }
	},

	watch: {
		for_customer(value) {
			if (value && this.document.customer_name === null) {
				this.customerDrawer = true;
			}
		}
	}
};
</script>
